<template>
    <div class="bbbb">
        <peaimage class="piaimage"></peaimage>
        <div :class="[showReport?'theReport':'reportHide']">
            <div class="openReport">
                <div class="optnBtn" v-html="showReport?'隐藏报告':'显示报告'" @click="openOrHide"></div>
            </div>
            <div class="report" v-if="showReport">
                <div class="title">
                    <span class="information">患者信息</span>
                    <span class="downLoadDcm" @click="closeReply"  v-if="isOpen == 1">
                        <Icon type="ios-close-circle-outline" />
                        <span>结束讨论</span>
                    </span>
                </div>
                <div class="reportBody">
                    <div class="PatientInformation">
                        <strong>姓名：</strong>
                        {{applicationForm.patientName}}
                    </div>
                    <div class="PatientInformation">
                        <strong>性别：</strong>
                        {{applicationForm.patientSex==0?'男':formData.patientSex==1?'女':'不详'}}
                    </div>
                    <div class="PatientInformation">
                        <strong>年龄：</strong>
                        {{applicationForm.patientAge}}
                    </div>
                    <div class="PatientInformation">
                        <strong>设备：</strong>
                        {{applicationForm.deviceType}}
                    </div>
                    <div class="PatientInformation">
                        <strong>科室：</strong>
                        {{applicationForm.applyOffice}}
                    </div>
                    <div class="PatientInformation">
                        <strong>床号：</strong>
                        {{applicationForm.bedNo}}
                    </div>
                    <div class="PatientInformation">
                        <strong>住院号：</strong>
                        {{applicationForm.hospitalNo}}
                    </div>
                    <div class="PatientInformation">
                        <strong>患者电话：</strong>
                        {{applicationForm.patientPhone}}
                    </div>
                    <div class="PatientInformation">
                        <strong>患者编号：</strong>
                        {{applicationForm.patientNo}}
                    </div>
                    <div class="PatientInformation">
                        <strong>检查日期：</strong>
                        {{patientCheckTime}}
                    </div>
                    <div class="PatientInformation">
                        <strong>检查部位：</strong>
                        {{applicationForm.checkPoint}}
                    </div>
                    <div class="PatientInformation">
                        <strong>检查方法：</strong>
                        {{checkMethod}}
                    </div>
                </div>
                <div>
                    <strong>病情描述：</strong>
                    {{applicationForm.describe}}
                </div>
                <div class="accessoriesBox" v-if="accessories&&accessories.length>0">
                    <strong>附件：</strong>
                    <viewer :images="accessories">
                        <img v-for="(img,index) in accessories" class="accessories" :src="'/api/file/acquisition/'+img" :key="index">
                    </viewer>
                </div>
                <div class="reportForm">
                    <div class="title">
                        <span class="information">疑难讨论</span>
                    </div>
                    <div>
                        <div v-for="i in replyData" class="replyBox">
                            <div class="replyMsg">
                                <Tag type="border" color="success">{{i.nickname}}</Tag>
                                <span class="msgdate">{{replyDate(i.replyDate)}}</span>
                            </div>
                            <p class="msg">{{i.replyContent}}</p>
                        </div>
                    </div>
                    <Form ref="formData" :model="formData" :rules="ruleValidate" label-position="top">
                        <FormItem prop= "replyContent"  v-if="isOpen == 1">
                            <Input v-model="formData.replyContent" type="textarea" :rows="4" placeholder="回复建议" />
                        </FormItem>
                        <FormItem>
                            <Button type="primary" @click="addReply('formData')" v-if="isOpen == 1">提交</Button>
                            <Button type="primary" @click="closeWindow('')">关闭</Button>
                        </FormItem>
                    </Form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Peaimage from '../components/Peaimage/Peaimage'
export default {
    data(){
        return{
            templateName:["公共模板","个人模板"],
            showReport:true,
            formData: {},
            ruleValidate: {
                replyContent: [
                    { required: true, message: '回复内容不能为空', trigger: 'blur' }
                ]
            },
            recordId: "",
            replyData: [],
            applicationForm: {},
            createAccountId: "",
            isOpen: ""
        }
    },
    computed: {
        replyDate() {
            return function(date) {
                return Base.dealWithTime(date)
            }
        },
        patientCheckTime(){
            return Base.dealWithTime(Number(this.applicationForm.patientCheckTime))
        },
        checkMethod(){
            if(this.applicationForm.checkMethod){
                return JSON.parse(this.applicationForm.checkMethod).join(',')
            }
        },
        accessories() {
            if(this.applicationForm.accessories) {
                return JSON.parse(this.applicationForm.accessories)
            }
        }
    },
    components:{
        Peaimage
    },
    methods:{
        openOrHide(){
            this.showReport=! this.showReport
        },
        _initData(){
            this.recordId = window.location.href.split('?')[1].split('&')[1].split('=')[1]
            let data = {
                id: this.recordId
            }
            this.$api.doctor.findByRecodeId(data).then(res => {
                this.applicationForm = res.data.applicationForm
                this.replyData = res.data.difficultReply
                this.createAccountId = res.data.createAccountId
                this.isOpen = res.data.isOpen
            })
            // if (this.reportFlow.imageMark && this.reportFlow.imageMark != '{}') {
            //     try {
            //         let marks = JSON.parse(this.reportFlow.imageMark);
            //         var markCount = 0;
            //         for (var st in marks) {
            //             if (marks.hasOwnProperty(st)) {
            //                 var se = marks[st];
            //                 for (var img in se) {
            //                     if (se.hasOwnProperty(img)) {
            //                         var img = se[img];
            //                         for (var fm in img) {
            //                             if (img.hasOwnProperty(fm)) {
            //                                 markCount++; // += img[fm].length;
            //                             }
            //                         }
            //                     }
            //                 }
            //             }
            //         }
            //         this.count=markCount
            //         window.CateyesPubSub.replyMarks = marks;//影像重新渲染
            //     } catch (e) {}
            // }
            // window.CateyesPubSub.on('AFTER_CATEYES_MARK', (e, count)=> {//获取标记张数
            //     this.count= count
            // });
        },
        closeWindow(data){
            setTimeout(() => {
                this.$Modal.confirm({
                    title: '关闭页面',
                    content: '点击确认关闭页面',
                    onOk: () => {
                        window.opener.postMessage('closeWriteHanding',"*")
                        window.close();
                    },
                    onCancel: () => {
                        window.opener.postMessage('closeWriteHanding',"*")
                        this._initData()
                    }
                })
            },500)
        },
        addReply(name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    let user = JSON.parse(window.sessionStorage.getItem("user"))
                    let data = {
                        replyContent: this.formData.replyContent,
                        recordId: this.recordId
                    }
                    this.$api.doctor.addReply(data).then(res => {
                        if(res.code == 0) {
                            this._initData()
                            this.$refs[name].resetFields();
                        }else {
                            this.$Message.info(res.msg)
                        }
                        
                    })
                }
            })
        },
        closeReply() {
             this.$Modal.confirm({
                title: '结束讨论',
                content: '确定结束讨论？',
                onOk: () => {
                    let data = {
                        id: this.recordId,
                        createAccountId: this.createAccountId,
                        isOpen: "0"
                    }
                    this.$api.form.updateDifficult(data).then(res => {
                        if(res.code == 0) {
                            this.closeWindow()
                        }else {
                            this.$Message.info(res.msg)
                        }
                    })
                }
            })
            
        }
    },
    mounted(){
        this._initData()
    }
}
</script>

<style lang="scss" scoped>
    .bbbb{
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
        display: flex;
        .peaimage{
            width: 90%;
        }
    }
    .reportHide{
        height: 100%;
        width: 30px;
        max-width: 95%;
        position: absolute;
        right: 0;
        top: 0;
        display: flex;
        .openReport{
            width: 30px;
            height: 100%;
            background: #2b85e4;
            position: absolute;
            .optnBtn{
                cursor: pointer;
                float: left;
                font-size: 26px;
                text-align: center;
                display: block;
                width: 30px;
                height: 180px;
                position: absolute;
                top:0;
                bottom: 0;
                left: 0;
                right: 0;
                margin: auto;
                color: white;
            }
        }
    }
    .theReport{
        height: 100%;
        width: 980px;
        max-width: 90%;
        position: absolute;
        right: 0;
        top: 0;
        display: flex;
        .openReport{
            width: 30px;
            height: 100%;
            background: #2b85e4;
            position: absolute;
            .optnBtn{
                cursor: pointer;
                float: left;
                font-size: 26px;
                text-align: center;
                display: block;
                width: 30px;
                height: 180px;
                position: absolute;
                top:0;
                bottom: 0;
                left: 0;
                right: 0;
                margin: auto;
                color: white;
            }
        }
        .report{
            margin-left: 30px;
            flex: 1;
            background: white;
            padding: 10px 20px;
            overflow: auto;
            .title{
                color: #2d8cf0;
                width: 100%;
                border-bottom:1px solid #dddddd; 
                margin-bottom: 10px;
                font-size: 14px;
                .information{
                    border-bottom: 2px solid #2d8cf0;
                    width: 100px;
                    line-height: 30px;
                    display: inline-block;
                }
                .downLoadDcm{
                    float: right;
                    color: #ed4014;
                    cursor: pointer;
                    line-height: 30px;
                    display: inline-block;
                }                
            }
            .reportBody{
                padding-bottom: 10px;
                &:after{
                    content: "";
                    display: block;
                    clear: both;
                }
                .PatientInformation{
                    float: left;
                    width: 220px;
                    font-size: 14px;
                }
            }
            .accessoriesBox{
                .accessories {
                    width: 100px;
                    margin-right: 2px;
                }
            }
            .reportForm{
                width: 100%;
                height: 100%;
                background: white;
                float: left;
                position: relative;
                .replyBox {
                    border-bottom: 1px solid #2b85e4;
                    margin-bottom: 10px;
                    .replyMsg {
                        line-height: 30px;
                        font-size: 14px;
                        margin-bottom: 10px;
                        .doctorName {
                            font-weight: 600;
                            margin-right: 10px;
                        }
                        .msgdate{
                            font-size: 12px;
                        }
                    }
                    .msg { 
                        font-size: 14px;
                        margin-bottom: 10px;
                        white-space: pre-wrap;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/discuss.vue